import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { getFirestore, collectionGroup, getDocs } from "firebase/firestore";
import { app } from "shared/lib/firebase";

const db = getFirestore(app);

function normalizeEvents(data) {
  return data?.events || {};
}

export function useAnalyticsReport({ startDate, endDate }) {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;

    async function load() {
      setLoading(true);
      setError(null);

      try {
        const snaps = await getDocs(collectionGroup(db, "days"));

        if (!active) return;

        const result = {};

        snaps.forEach((docSnap) => {
          const date = docSnap.id;
          const refPath = docSnap.ref.path;

          const brand = refPath.split("/")[1];

          if (startDate && endDate) {
            const d = dayjs(date);
            if (d.isBefore(startDate, "day") || d.isAfter(endDate, "day")) {
              return;
            }
          }

          if (!result[brand]) {
            result[brand] = {};
          }

          result[brand][date] = normalizeEvents(docSnap.data());
        });

        setData(result);
      } catch (err) {
        console.error("Erro ao carregar dados", err);
        setError(err);
      } finally {
        if (active) setLoading(false);
      }
    }

    load();

    return () => {
      active = false;
    };
  }, [startDate, endDate]);

  return {
    data,
    loading,
    error,
  };
}
